var MuiDialogContentText = {
    gutterBottom: true,
};
export default MuiDialogContentText;
//# sourceMappingURL=MuiDialogContentText.js.map